<template>
    <div class="card-photo">
        <img :src="photo" :alt="alt" v-if="photo !== null" />
        <Button class="card-photo__remove" :svg-icon="trashIcon" @click="handleRemove" v-if="!isHideRemoveBtn" />
    </div>
</template>

<script setup>
import {defineProps, onMounted, ref, defineEmits} from 'vue';

import { Button } from "@progress/kendo-vue-buttons";
import { trashIcon  } from "@progress/kendo-svg-icons";

const props = defineProps({
    img: {
        type: String,
        required: true
    },
    alt: {
        type: String,
        required: false,
        alt: 'Картинка'
    },
    file: {
        type: Object,
        required: false,
        default: null
    },
    isGenerate: {
        type: Boolean,
        required: false,
        default: null
    },
    index: {
      type: Number,
      required: false,
      default: null
    },
  isHideRemoveBtn: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emits = defineEmits(['remove']);

const photo = ref(null);

const generatePhoto = () => {
    const reader = new FileReader();
    reader.onloadend = (ev) => {
        photo.value = ev.target.result;
    };

    if(props?.file?.url) {
        photo.value = props.file.url;
    } else {
        reader.readAsDataURL(props.file.getRawFile());
    }
}

const init = () => {
    if(!props.isGenerate) {
        photo.value = props.img;
    } else {
        generatePhoto();
    }
}

const handleRemove = () => {
    emits('remove', {index: props.index, photo: props.file});
}

onMounted(() => {
    init();
})
</script>

<style lang="scss">
.card-photo {
    position: relative;
    height: 128px;
    width: 128px;

    & img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    &__remove {
        position: absolute;
        top: 0;
        right: 0;
    }
}
</style>